
'use strict';
import angular from 'angular';
import yelpCategoriesHtmlUrl from './views/yelpCategoriesList.html';
var app = angular.module('app.yelpCategories.component', []);
app.component('yelpAdsCategories', {
    bindings: {
        showActions: '<',
        selectedYelpCategory: '=',
        clusterId: '=',
        isFormEdit: '=',
        clientId: '='
    },
    templateUrl: yelpCategoriesHtmlUrl,
    controller: function (ProductService) {
        var self = this;
        self.selectedCategory = '';
        self.yelpCategoriesList = [];
        self.toggleCategoriesList = function () {
            self.showActions = !self.showActions;
        };
        self.selectCategory = function (category) {
            self.selectedCategory = category.name;
            self.showActions = false;
            self.selectedYelpCategory = self.yelpCategoriesList.filter(function (item) {
                return item.name === self.selectedCategory;
            });
        };
        self.getYelpCategory = function () {
            var selectedYelpCategory = self.selectedCategory;
            ProductService.getYelpCategoryContents({
                clientId: self.clientId,
                clusterId: self.clusterId
            }).then(function (success) {
                if (success && success.data && success.data.length > 0) {
                    _.each(success.data, function (contentArray) {
                        _.each(contentArray, function (categoryName) {
                            var categories = {
                                name: categoryName
                            };
                            self.yelpCategoriesList.push(categories);
                        });
                    });
                    _.each(self.selectedYelpCategory, function (item) {
                        item.yelpCategoriesList = angular.copy(self.yelpCategoriesList);
                    })
                }
            }, function (error) {
            });
        }
        self.initComponent = function () {
            if (self.selectedYelpCategory && !_.isEmpty(self.selectedYelpCategory)) {
                self.selectedYelpCategory = JSON.parse(self.selectedYelpCategory);
                self.showActions = self.isFormEdit;
                self.editMode = true;
                self.enableViewMode = false;
                self.getYelpCategory();
            } else {
                self.selectedYelpCategory = '';
                self.showActions = false;
                self.enableViewMode = false;
                self.getYelpCategory();
            }
            if (self.selectedYelpCategory != '') {
                self.selectedCategory = self.selectedYelpCategory[0].name;
            }
        };
        self.initComponent();
    }
});